/* eslint-disable camelcase */

import shouldShowQuickShadesProductVariantSelectorUtil from 'modules/product-variant/redux/selectors/should-show-quick-shades/utils'

/**
 * @param {ProductVariantCollection} featuredProductVariant
 * @param {Boolean} isExtraExtraSmallScreen
 */
const shouldShowQuickShadesProductVariantSelector = ({
  featuredProductVariant,
  isExtraExtraSmallScreen
}) => {
  return state => shouldShowQuickShadesProductVariantSelectorUtil({
    featuredProductVariant,
    isExtraExtraSmallScreen,
    state
  })
}

export default shouldShowQuickShadesProductVariantSelector
